const listInitialState = {
  page: 1,
  perPage: 20,
  filters: {},
  selectedItems: [],
  search: '',
}

export default listInitialState
